var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-family":"'メイリオ', 'Meiryo', sans-serif","color":"rgb(0, 0, 0)"},attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }